export default "__VITE_ASSET__CbyJ_Bu4__"